import Vue from 'vue'
import router from '@/router'
import store from '@/store'
export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

// 生成代替头像的文字
export function getAvatarText(string) {
  const str = string
  if (/^\d+$/.test(str)) {
    return str.split('').pop()
  }
  if (escape(str).indexOf('%u') < 0) {
    return str.split(' ').pop()
  } else {
    return str.split('').pop()
  }
}

// 判断是否是连续数字
export function isSerialNumber(str) {
  if (str.length < 2) return false
  for (let i = 0, l = str.length; i < l - 1; i++) if (Math.abs((str.charCodeAt(i) - str.charCodeAt(i + 1))) !== 1) return false
  return true
}

// 判断是否连续相同的字符
export function sameChar(string) {
  const regx = /^(.)\1+$/
  return regx.test(string)
}

// 生成随机颜色
export function getRandomColor(colors = ['#ff5c0f', '#01ffff', '#66cbff', '#c984a1', '#72716f', '#b40047']) {
  const index = Math.round(Math.random() * (colors.length - 1))
  return colors[index]
}

// 弹出退出确认框的逻辑
export function confirmLogin (direct) {
  store.dispatch('ClearToken')
  // 登录页、超级登录、忘记密码均不弹出
  const proWhiteList = ['/ucs/login/page', '/ucs/login/forgetpwd', '/ucs/login/superlogin']
  // const devWhiteList = ['/login/page', '/login/forgetpwd', '/login/superlogin']
  const whiteList = proWhiteList
  const loginPath = whiteList.find(item => window.location.pathname.startsWith(item))
  if (loginPath) return
  if (direct) {
    router.replace({ name: 'CommonLogin' })
    return
  }
  Vue.prototype.$showLogin()
}

export function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
